import { Card } from 'flowbite-react';
import { Dispatch } from 'react';

export function DashboardInstructions({
  setOpenModal,
}: {
  setOpenModal: Dispatch<React.SetStateAction<boolean>> | undefined;
}) {
  return (
    <Card>
      <div className='text-md mb-4 flex w-full font-medium text-gray-900'>
        <span>Recording Instructions</span>
      </div>
      <div className='grid gap-6 md:grid-cols-2'>
        <div>
          <div className='text-md mb-6 font-medium text-gray-900'>
            This is the part where you record your awesome videos!
          </div>
          <div className='mb-6 flex w-full justify-start'>
            View the instructions for how to record your videos below. Check out the video to the
            right for a quick explainer.
          </div>
          <div className='mb-6 flex w-full justify-start'>
            If you&apos;d like to see some best practices and sample videos for different use cases,
            click on the Get Inspiration button below!
          </div>
          <div>
            <a
              className='group relative mb-2 mr-2 inline-flex items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br from-purple-600 to-blue-500 p-0.5 text-sm font-medium text-gray-900 hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300 group-hover:from-purple-600 group-hover:to-blue-500'
              onClick={setOpenModal ? () => setOpenModal(true) : undefined}
              {...(setOpenModal === undefined && {
                href: 'https://trymaverick.notion.site/Onboarding-Instructions-3f91edea8e74409dbc855af9039a9153',
                rel: 'noreferrer',
                target: '_blank',
              })}
            >
              <span className='relative rounded-md bg-white px-5 py-2.5 transition-all duration-75 ease-in group-hover:bg-opacity-0'>
                View Instructions
              </span>
            </a>
            <a
              className='group relative mb-2 mr-2 inline-flex items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br from-purple-600 to-blue-500 p-0.5 text-sm font-medium text-gray-900 hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300 group-hover:from-purple-600 group-hover:to-blue-500'
              onClick={setOpenModal ? () => setOpenModal(true) : undefined}
              {...(setOpenModal === undefined && {
                href: 'https://trymaverick.notion.site/Video-Inspiration-75ea59fff7674bab8c75aa71fbd57ce4',
                rel: 'noreferrer',
                target: '_blank',
              })}
            >
              <span className='relative rounded-md bg-white px-5 py-2.5 transition-all duration-75 ease-in group-hover:bg-opacity-0'>
                Get Inspiration
              </span>
            </a>
          </div>
        </div>
        <div className='mb-6 flex w-full items-center justify-center'>
          {setOpenModal && (
            <img
              alt='video instructions'
              className='object-contain'
              src='https://storage.googleapis.com/mavid-311321.appspot.com/Maverick%20-%20Onboarding%20Video%20Thumbnail.png'
              onClick={setOpenModal ? () => setOpenModal(true) : undefined}
            ></img>
          )}
          {setOpenModal === undefined && (
            <video className='h-auto w-full max-w-full rounded-lg border border-gray-200' controls>
              <source
                src='https://storage.googleapis.com/mavid-311321.appspot.com/Maverick%20-%20Onboarding%20Video.mp4'
                type='video/mp4'
              ></source>
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </div>
    </Card>
  );
}
